import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { pathOr } from 'ramda';
import componentBase from '../../../src/lib/component-base';

@connect(
  state => ({
    routing: state.routing,
  }),
  null,
  null,
  {
    withRef: true,
  },
)
@componentBase('Ad')
export default class Ad extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    sizes: PropTypes.array,
    adSlot: PropTypes.string,
    style: PropTypes.object,
    width: PropTypes.number,
    height: PropTypes.number,
    subscriptionActive: PropTypes.bool,
    noAdOnLoad: PropTypes.bool,
    routing: PropTypes.object,
  };

  componentDidMount() {
    window.googletag = window.googletag || {};
    googletag.cmd = googletag.cmd || [];

    if (!this.props.noAdOnLoad && !this.props.subscriptionActive && !this.adSlotExists()) {
      this.pathname = this.props.routing.location.pathname;
      this.defineAndEnableAd();
      this.displayAd(this.props.id);
    }
  }

  shouldComponentUpdate(nextProps) {
    const nextPathname = pathOr('', ['routing', 'location', 'pathname'], nextProps);
    if (!this.routesMatch(nextPathname)) {
      this.pathname = nextPathname;
      return true;
    // } else if (nextProps.id !== this.props.id) {
    //   this.destroySlot();
    //   return true;
    }
    return false;
  }

  componentDidUpdate() {
    if (!this.props.noAdOnLoad && !this.props.subscriptionActive) {
      if (!this.adSlotExists()) { // If the adslot does not exist, update
        this.defineAndEnableAd();
        this.displayAd(this.props.id);
      } else if (googletag && googletag.apiReady) {
        googletag.pubads().refresh([this.slot]);
      }
    }
  }

  componentWillUnmount() {
    this.destroySlot();
  }

  routesMatch(nextPathname) {
    const basicMatch = this.pathname === nextPathname;
    const slashMatchFirst = ''.concat(this.pathname, '/') === nextPathname;
    const slashMatchSecond = this.pathname === ''.concat(nextPathname, '/');
    return basicMatch || slashMatchFirst || slashMatchSecond;
  }

  destroySlot() {
    if (googletag && googletag.apiReady) {
      googletag.destroySlots([this.slot]);
      this.slot = null;
    }
  }

  displayAd(id) {
    if (googletag && googletag.apiReady && !this.props.subscriptionActive) {
      googletag.cmd.push(() => {
        googletag.display(id);
      });
    }
  }

  defineAndEnableAd() {
    if (googletag && googletag.apiReady && !this.props.subscriptionActive) {
      this.slot = googletag.defineSlot(this.props.adSlot, this.props.sizes, this.props.id);
      if (this.slot) {
        this.slot.addService(googletag.pubads());
        googletag.cmd.push(() => {
          googletag.pubads().enableSingleRequest();

          // Causes google_console warning
          // "Ignoring subsequent call to set div collapse mode (already set)."
          googletag.pubads().collapseEmptyDivs();

          googletag.enableServices();
        });
      }
    }
  }

  adSlotExists() {
    try {
      if (googletag && googletag.apiReady) {
        return this.slot.getSlotElementId() === (this.props.id);
      }

      return false;
    } catch (ex) {
      return false;
    }
  }

  render() {
    if (this.props.subscriptionActive) {
      return null;
    }

    const style = {
      ...this.props.style,
      width: this.props.width,
      height: this.props.height,
    };

    return (
      <div className='Ad' style={style}>
        <div id={this.props.id} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/components/Ad/Ad.js